/**
 * GelComponent
 *
 * This component represents the main gel visualization area. It can display multiple gel bands
 * and is capable of integrating with the Redux store to fetch and visualize additional gel bands.
 *
 * This component also handles the background image for the gel.
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import GelBand from "./gelBand";
import styles from "./style.module.scss";

class BaseGelComponent extends React.Component {
  render() {
    return (
      <div className={styles.Gel}>
        <div className={styles.Lanes}>
          {/* Iterates over the bands and creates GelBand components for each one */}
          {Object.entries(this.props.bands).map(([index, item]) => (
            <GelBand
              key={item.id}
              {...item}
              controls={this.props.component_type === "predicts"}
              component_type={this.props.component_type}
            />
          ))}
        </div>
        <img
          src={this.props.background_image.replace(
            "{{locale}}",
            this.props.intl.locale
          )}
          alt=""
        />
      </div>
    );
  }
}

// Type validation for the props
BaseGelComponent.propTypes = {
  component_type: PropTypes.string.isRequired,
  background_image: PropTypes.string.isRequired,
  bands: PropTypes.array.isRequired,
};

/**
 * Maps the Redux state to the component's props.
 *
 * @param {object} state - The current state from the Redux store.
 * @param {object} ownProps - The props passed to the component.
 * @returns {object} - Mapped props.
 */
function mapStateToProps(state, ownProps) {
  if (ownProps.component_type === "results" && state.gel.results) {
    return {
      bands: ownProps.bands.concat(Object.values(state.gel.results)),
    };
  }
  return {
    bands: ownProps.bands,
  };
}

export const GelComponent = connect(mapStateToProps)(
  injectIntl(BaseGelComponent)
);
